import type { EntityConfig } from '../types'

export const networkTokenEntity: EntityConfig = {
  id: 'network-token',
  displayName: 'Network Token',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'suspended', label: 'Suspended' },
      { value: 'deleted', label: 'Deleted' },
      { value: 'expired', label: 'Expired' },
    ],
    options: [
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'suspended', label: 'Suspended', color: 'warning' },
      { value: 'deleted', label: 'Deleted', color: 'error' },
      { value: 'expired', label: 'Expired', color: 'neutral' },
    ],
    mappings: {
      all: [],
      active: ['active'],
      suspended: ['suspended'],
      deleted: ['deleted'],
      expired: ['expired'],
    },
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    dateRange: { type: 'date_range', urlKey: 'date' },
    network: { type: 'string_array', urlKey: 'network' },
    search: { type: 'search', urlKey: '$s' },
  },
  uiFilterFields: ['search', 'status', 'dateRange', 'network'],
}
